import { useState, useEffect } from "react";
import Chart from "react-apexcharts";

export default function SummaryChart(props) {
  const [outcomeData, setOutcomeData] = useState([]);
  const [chart, setChart] = useState({});
  const [chartOutcomeData, setChartOutcomeData] = useState([]);
  const [totalDossierQty, setTotalDossierQty] = useState();

  useEffect(() => {
    if (props.filteredData.length > 0) {
      getChartData();
    } else {
      setChartOutcomeData([]);
    }
  }, [
    props.filteredData,
    props.selectedChart,
    props.selectedModel,
    props.selectedAspect,
    props.selectedSize,
    props.selectedOutcome,
  ]);

  useEffect(() => {
    handleState();
  }, [chartOutcomeData]);

  const getChartData = () => {
    let data = props.filteredData;
    let totalQty = 0;
    data.forEach((el) => (totalQty += el.renderedQty));
    setTotalDossierQty(totalQty);
    setChartOutcomeData(props.filteredData);
  };

  const getColorArray = () => {
    let colors = [];
    if (props.selectedChart == "outcome") {
      chartOutcomeData.map((data) => {
        let found = props.outcomesInfo.find(
          (x) => x.idAnagOutcome == data.value
        );
        let color = "";
        if (found.severity == "Major") {
          color = "#FF0000";
        } else if (found.severity == "Minor") {
          color = "#008000";
        } else if (found.severity == "Warning") {
          color = "#808080";
        } else {
          color = "#808080";
        }
        colors.push(color);
      });
    } else {
      chartOutcomeData.map((x) => {
        colors.push("#008000");
      });
    }

    return colors;
  };

  const handleState = () => {
    setChart({
      series: [
        {
          data: chartOutcomeData.map(
            (x) => (x.renderedQty * 100) / totalDossierQty
          ),
        },
      ],
      options: {
        chart: {
          type: "bar",
          toolbar: {
            show: false,
          }
        },
        plotOptions: {
          bar: {
            horizontal: true,
            distributed: true,
            barHeight: '20px',
          },
        },
        grid: {
          padding: {
            top: 15,
          }
        },
        dataLabels: {
          enabled: false,
        },
        xaxis: {
          position: "top",
        },
        yaxis: {
          max: 100,
          labels: {
            show: false,
          },
        },
        tooltip: {
          enabled: false,
        },
        colors: props.selectedChart.length > 0 ? getColorArray() : ["#008000"],
      },
    });
  };

  return chartOutcomeData.length != 0 ? (
    <div>
      <Chart
        options={chart.options}
        series={chart.series}
        type="bar"
        height={(props.filteredData.length * 44) + 100}
      />
    </div>
  ) : (
    <div></div>
  );
}
